/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SkipAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SkipConfirmation from './SkipConfirmation/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SkipAction({
  children,
  viewPath = "/DesignSystem/CheckIn/AssignConnection/Content/Content/SkipAction",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let selectedConnectionIdIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected_connection',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="selected_connection.id"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './SkipConfirmation/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './SkipConfirmation/Content'))}
 disabled={selectedConnectionIdIsSubmittingData}
 type="secondary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Skip"
/>
)}
</TysiaButton>
<SkipConfirmation
  viewPath={`${viewPath}/SkipConfirmation`}
/>
{children}
</React.Fragment>)
}